/*
 * @Date: 2024-06-14 16:21:42
 * @LastEditTime: 2024-07-02 10:13:52
 */
import { BASE_URL } from "@/services/api";
import { request, METHOD } from "@/utils/request";

export async function upsertClickLog(params) {
  return request(`${BASE_URL}/clickLog/upsert`, METHOD.POST, params);
}
